(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coleccion-lino"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ctInit) return;
      root.dataset.ctInit = '1';

      var tabs = root.querySelectorAll('[data-ct-tab]');
      var panels = root.querySelectorAll('[data-ct-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var idx = tab.getAttribute('data-ct-tab');
          tabs.forEach(function (t) {
            var esActiva = t === tab;
            t.classList.toggle('esta-activa', esActiva);
            t.setAttribute('aria-selected', esActiva ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('esta-activo', p.getAttribute('data-ct-panel') === idx);
          });
        });
      });
    }

    function initAll() {
      document.querySelectorAll('.coleccion-tabs').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciarSeccion(seccion) {
      if (seccion.dataset.carruselIniciado === 'true') return;

      var pista = seccion.querySelector('.colecciones-rios__rejilla');
      var puntos = seccion.querySelectorAll('.colecciones-rios__punto');
      var tarjetas = seccion.querySelectorAll('.colecciones-rios__tarjeta');

      if (!pista || puntos.length === 0 || tarjetas.length === 0) return;

      seccion.dataset.carruselIniciado = 'true';

      var indiceActual = -1;
      var pendiente = false;

      function calcularIndice() {
        var estilos = window.getComputedStyle(pista);
        var relleno = parseFloat(estilos.paddingLeft) || 0;
        var referencia = pista.scrollLeft + relleno;
        var maximo = pista.scrollWidth - pista.clientWidth;

        if (maximo > 0 && pista.scrollLeft >= maximo - 1) {
          return tarjetas.length - 1;
        }

        var indiceCercano = 0;
        var distanciaMinima = Infinity;

        for (var i = 0; i < tarjetas.length; i++) {
          var distancia = Math.abs(tarjetas[i].offsetLeft - referencia);
          if (distancia < distanciaMinima) {
            distanciaMinima = distancia;
            indiceCercano = i;
          }
        }

        return indiceCercano;
      }

      function pintar() {
        pendiente = false;

        var indice = calcularIndice();
        if (indice === indiceActual) return;

        indiceActual = indice;

        for (var i = 0; i < puntos.length; i++) {
          if (i === indice) {
            puntos[i].classList.add('colecciones-rios__punto--activo');
          } else {
            puntos[i].classList.remove('colecciones-rios__punto--activo');
          }
        }
      }

      function alDesplazar() {
        if (pendiente) return;
        pendiente = true;
        window.requestAnimationFrame(pintar);
      }

      pista.addEventListener('scroll', alDesplazar, { passive: true });
      window.addEventListener('resize', alDesplazar, { passive: true });

      for (var j = 0; j < puntos.length; j++) {
        puntos[j].addEventListener('click', function (evento) {
          var indice = parseInt(evento.currentTarget.getAttribute('data-indice'), 10);
          var destino = tarjetas[indice];
          if (!destino) return;
          var estilos = window.getComputedStyle(pista);
          var relleno = parseFloat(estilos.paddingLeft) || 0;
          pista.scrollTo({ left: destino.offsetLeft - relleno, behavior: 'smooth' });
        });
      }

      pintar();
    }

    function iniciar() {
      var secciones = document.querySelectorAll('.colecciones-rios--carrusel');
      for (var i = 0; i < secciones.length; i++) {
        iniciarSeccion(secciones[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var consulta = window.matchMedia('(min-width: 749px)');

    function sincronizar(seccion) {
      var desplegables = seccion.querySelectorAll('.pie-rios__menu--desplegable');
      for (var i = 0; i < desplegables.length; i++) {
        if (consulta.matches) {
          desplegables[i].setAttribute('open', '');
        } else {
          desplegables[i].removeAttribute('open');
        }
      }
    }

    function iniciar() {
      var secciones = document.querySelectorAll('.pie-rios--acordeon');
      for (var i = 0; i < secciones.length; i++) {
        sincronizar(secciones[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    if (consulta.addEventListener) {
      consulta.addEventListener('change', iniciar);
    } else if (consulta.addListener) {
      consulta.addListener(iniciar);
    }

    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-productos-nuevos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function rootUrl() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function actualizarBurbuja(res) {
      if (!res.sections || !res.sections['cart-icon-bubble']) return;
      var burbuja = document.getElementById('cart-icon-bubble');
      if (!burbuja) return;
      var doc = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      var nueva = doc.getElementById('cart-icon-bubble');
      if (nueva) burbuja.innerHTML = nueva.innerHTML;
    }

    function abrirCajon(res) {
      actualizarBurbuja(res);

      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        try { drawer.renderContents(res); } catch (e) {}
        if (typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
        return;
      }

      var notification = document.querySelector('cart-notification');
      if (notification && typeof notification.renderContents === 'function') {
        try { notification.renderContents(res); } catch (e) {}
        return;
      }

      var eventos = ['cart:refresh', 'cart:updated', 'cart:build', 'cart:change', 'ajaxProduct:added', 'product:added', 'cart:open', 'cart-drawer:open', 'openCartDrawer'];
      eventos.forEach(function (nombre) {
        document.dispatchEvent(new CustomEvent(nombre, { bubbles: true, detail: { cart: res } }));
      });

      setTimeout(clicarIconoCarrito, 120);
    }

    function clicarIconoCarrito() {
      var selectores = [
        '#cart-icon-bubble',
        '[data-cart-drawer-toggle]',
        '[data-drawer-toggle="cart"]',
        '[data-cart-toggle]',
        '[data-action="open-cart"]',
        '[aria-controls="cart-drawer"]',
        '.js-drawer-open-cart',
        '.cart-toggle',
        '.header__icon--cart',
        '.site-header__cart',
        '.header-cart',
        '#cart-icon',
        'a[href$="/cart"]'
      ];
      for (var i = 0; i < selectores.length; i++) {
        var el = document.querySelector(selectores[i]);
        if (el) {
          el.click();
          return;
        }
      }
    }

    function anadirAlCarrito(variantId, boton) {
      if (!variantId) return;
      if (boton) boton.classList.add('gpn-anadiendo');

      fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: 'cart-drawer,cart-notification,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (boton) boton.classList.remove('gpn-anadiendo');
          if (res.status) { return; }
          abrirCajon(res);
        })
        .catch(function () {
          if (boton) boton.classList.remove('gpn-anadiendo');
        });
    }

    function actualizarBarra(contenedor, thumb, minAncho) {
      var track = thumb.parentElement;
      var trackW = track ? track.clientWidth : 0;
      var max = contenedor.scrollWidth - contenedor.clientWidth;
      if (trackW <= 0 || max <= 2) {
        thumb.style.width = '100%';
        thumb.style.transform = 'translateX(0px)';
        return;
      }
      var propor = contenedor.clientWidth / contenedor.scrollWidth;
      var thumbW = Math.max(trackW * propor, trackW * (minAncho / 100));
      var frac = contenedor.scrollLeft / max;
      if (frac < 0) { frac = 0; }
      if (frac > 1) { frac = 1; }
      thumb.style.width = thumbW + 'px';
      thumb.style.transform = 'translateX(' + (frac * (trackW - thumbW)) + 'px)';
    }

    var barrasRegistradas = [];
    var frameDebug = 0;

    (function bucleBarras() {
      for (var i = 0; i < barrasRegistradas.length; i++) {
        var b = barrasRegistradas[i];
        try { actualizarBarra(b.c, b.t, b.m); } catch (e) {}
      }
      frameDebug++;
      var dbg = document.querySelector('[data-gpn-debug]');
      if (dbg) {
        var g = document.querySelector('.gpn-grid');
        var st = document.querySelector('[data-gpn-progreso-thumb]');

        var cards = document.querySelectorAll('.gpn-tarjeta');
        var centro = window.innerWidth / 2;
        var mejor = null, mejorDist = 1e9;
        for (var k = 0; k < cards.length; k++) {
          var r = cards[k].getBoundingClientRect();
          var d = Math.abs((r.left + r.right) / 2 - centro);
          if (d < mejorDist) { mejorDist = d; mejor = cards[k]; }
        }
        var sActual = mejor ? mejor.querySelector('[data-gpn-slider]') : null;
        var thActual = mejor ? mejor.querySelector('[data-gpn-img-progreso-thumb]') : null;

        dbg.textContent =
          'SEC despl:' + (g ? Math.round(g.scrollLeft) + '/' + Math.round(g.scrollWidth - g.clientWidth) : '?') +
          ' barraSEC:' + (st ? st.style.transform : '?') +
          ' || FOTO despl:' + (sActual ? Math.round(sActual.scrollLeft) + '/' + Math.round(sActual.scrollWidth - sActual.clientWidth) : 'sin-slider') +
          ' barraFOTO:' + (thActual ? thActual.style.transform : 'sin-barra');
      }
      requestAnimationFrame(bucleBarras);
    })();

    function conectarBarra(contenedor, thumb, minAncho) {
      if (!contenedor || !thumb) return;
      barrasRegistradas.push({ c: contenedor, t: thumb, m: minAncho });
    }

    function initProgreso(seccion) {
      var grid = seccion.querySelector('.gpn-grid');
      if (!grid) return;

      conectarBarra(grid, seccion.querySelector('[data-gpn-progreso-thumb]'), 15);

      function anchoTarjeta() {
        var t = grid.querySelector('.gpn-tarjeta');
        if (!t) return grid.clientWidth;
        var gap = parseFloat(getComputedStyle(grid).columnGap || getComputedStyle(grid).gap) || 0;
        return t.getBoundingClientRect().width + gap;
      }

      var prev = seccion.querySelector('[data-gpn-carrusel-prev]');
      var next = seccion.querySelector('[data-gpn-carrusel-next]');
      if (prev) prev.addEventListener('click', function () {
        grid.scrollBy({ left: -anchoTarjeta(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        grid.scrollBy({ left: anchoTarjeta(), behavior: 'smooth' });
      });
    }

    function initSeccion(seccion) {
      initProgreso(seccion);

      var wraps = seccion.querySelectorAll('[data-gpn-wrap]');
      wraps.forEach(function (wrap) {
        wrap.addEventListener('mouseenter', function () {
          wrap.classList.add('gpn-activa');
        });

        wrap.addEventListener('touchstart', function () {
          wraps.forEach(function (w) {
            if (w !== wrap) w.classList.remove('gpn-activa');
          });
          wrap.classList.add('gpn-activa');
        }, { passive: true });

        wrap.querySelectorAll('[data-gpn-add]').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (btn.disabled) return;
            anadirAlCarrito(btn.getAttribute('data-gpn-add'), btn);
          });
        });

        wrap.addEventListener('mouseleave', function () {
          wrap.classList.remove('gpn-activa');
          wrap.classList.remove('gpn-sin-velo');
        });

        var slides = wrap.querySelectorAll('[data-gpn-slide]');
        if (slides.length < 2) return;

        var siguiente = wrap.querySelector('[data-gpn-siguiente]');
        var anterior = wrap.querySelector('[data-gpn-anterior]');
        var slider = wrap.querySelector('[data-gpn-slider]');
        var actual = 0;

        var tarjeta = wrap.closest('.gpn-tarjeta');
        if (tarjeta) {
          conectarBarra(slider, tarjeta.querySelector('[data-gpn-img-progreso-thumb]'), 20);
        }

        function esMovil() {
          return window.matchMedia('(max-width: 748px)').matches;
        }

        function ir(direccion) {
          if (esMovil() && slider) {
            slider.scrollBy({ left: direccion * slider.clientWidth, behavior: 'smooth' });
            return;
          }
          slides[actual].classList.remove('gpn-slide--activa');
          actual = (actual + direccion + slides.length) % slides.length;
          slides[actual].classList.add('gpn-slide--activa');
          wrap.classList.add('gpn-sin-velo');
        }

        if (siguiente) {
          siguiente.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            ir(1);
          });
        }

        if (anterior) {
          anterior.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            ir(-1);
          });
        }
      });
    }

    function boot() {
      document.querySelectorAll('.gpn-seccion').forEach(initSeccion);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target.querySelector('.gpn-seccion');
      if (sec) initSeccion(sec);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function mover() {
      var enPlantilla = [];
      document.querySelectorAll('.encabezado-flotante-wrapper, .encabezado-flotante-menu, .ef-carrito').forEach(function (el) {
        if (el.parentNode !== document.body) enPlantilla.push(el);
      });
      if (enPlantilla.length) {
        document.querySelectorAll('body > .encabezado-flotante-wrapper, body > .encabezado-flotante-menu, body > .ef-carrito').forEach(function (v) {
          v.parentNode.removeChild(v);
        });
        enPlantilla.forEach(function (el) {
          document.body.appendChild(el);
        });
      }
    }

    function sincronizar(abierto) {
      var boton = document.querySelector('[data-abrir-menu]');
      var menu = document.querySelector('.encabezado-flotante-menu');
      if (boton) boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      if (menu) menu.setAttribute('aria-hidden', abierto ? 'false' : 'true');
      document.body.style.overflow = abierto ? 'hidden' : '';
    }

    function cerrarMenu() {
      document.body.classList.remove('ef-menu-abierto');
      document.querySelectorAll('.encabezado-flotante-desplegable.ef-desplegable-activo').forEach(function (d) {
        d.classList.remove('ef-desplegable-activo');
        var b = d.querySelector('[data-toggle-desplegable]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      sincronizar(false);
    }

    function alternarMenu() {
      mover();
      var abierto = document.body.classList.toggle('ef-menu-abierto');
      sincronizar(abierto);
    }

    function alternarDesplegable(boton) {
      var padre = boton.closest('.encabezado-flotante-desplegable');
      if (!padre) return;
      var activo = padre.classList.toggle('ef-desplegable-activo');
      boton.setAttribute('aria-expanded', activo ? 'true' : 'false');
    }

    function abrirCarrito() {
      mover();
      document.body.classList.add('ef-carrito-abierto');
      document.body.style.overflow = 'hidden';
      var c = document.querySelector('.ef-carrito');
      if (c) c.setAttribute('aria-hidden', 'false');
      refrescarCarrito();
    }

    function cerrarCarrito() {
      document.body.classList.remove('ef-carrito-abierto');
      if (!document.body.classList.contains('ef-menu-abierto')) {
        document.body.style.overflow = '';
      }
      var c = document.querySelector('.ef-carrito');
      if (c) c.setAttribute('aria-hidden', 'true');
    }

    function refrescarCarrito() {
      var cont = document.querySelector('.ef-carrito');
      if (!cont) return;
      var id = cont.getAttribute('data-seccion-id');
      fetch('/?sections=' + id)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data[id];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nuevoPanel = doc.querySelector('.ef-carrito-panel');
          var panel = document.querySelector('.ef-carrito-panel');
          if (nuevoPanel && panel) panel.innerHTML = nuevoPanel.innerHTML;
          var nuevoBadge = doc.querySelector('[data-contador-carrito]');
          var badge = document.querySelector('[data-contador-carrito]');
          if (nuevoBadge && badge) {
            badge.textContent = nuevoBadge.textContent;
            if (nuevoBadge.hasAttribute('hidden')) { badge.setAttribute('hidden', ''); } else { badge.removeAttribute('hidden'); }
          }
        })
        .catch(function () {});
    }

    function cambiarCantidad(linea, cantidad) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(linea, 10), quantity: parseInt(cantidad, 10) })
      })
        .then(function (r) { return r.json(); })
        .then(function () { refrescarCarrito(); })
        .catch(function () {});
    }

    var conectado = false;
    function conectar() {
      if (conectado) return;
      conectado = true;

      document.addEventListener('click', function (e) {
        if (!e.target.closest) return;
        if (e.target.closest('[data-toggle-desplegable]')) {
          e.preventDefault();
          alternarDesplegable(e.target.closest('[data-toggle-desplegable]'));
        } else if (e.target.closest('[data-abrir-menu]')) {
          e.preventDefault();
          alternarMenu();
        } else if (e.target.closest('[data-cerrar-menu]')) {
          cerrarMenu();
        } else if (e.target.closest('[data-abrir-carrito]')) {
          e.preventDefault();
          abrirCarrito();
        } else if (e.target.closest('[data-cerrar-carrito]')) {
          cerrarCarrito();
        } else if (e.target.closest('[data-cambiar]')) {
          var bc = e.target.closest('[data-cambiar]');
          cambiarCantidad(bc.getAttribute('data-linea'), bc.getAttribute('data-cantidad'));
        } else if (e.target.closest('[data-eliminar]')) {
          var be = e.target.closest('[data-eliminar]');
          cambiarCantidad(be.getAttribute('data-linea'), 0);
        } else if (document.body.classList.contains('ef-carrito-abierto') && e.target.closest('.ef-carrito') && !e.target.closest('.ef-carrito-panel')) {
          cerrarCarrito();
        }
      });

      document.addEventListener('submit', function (e) {
        var form = e.target.closest('form');
        if (!form) return;
        var accion = form.getAttribute('action') || '';
        if (accion.indexOf('/cart/add') === -1) return;
        e.preventDefault();
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json(); })
          .then(function () {
            cerrarMenu();
            abrirCarrito();
          })
          .catch(function () {});
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { cerrarMenu(); cerrarCarrito(); }
      });
    }

    function iniciar() {
      mover();
      conectar();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
    document.addEventListener('shopify:section:load', function () {
      mover();
      cerrarMenu();
      cerrarCarrito();
    });
    document.addEventListener('shopify:section:select', mover);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TAMANO_BASE = 100;

    function ajustarElemento(elemento) {
      var medida = elemento.querySelector('.banner-rios__medida');
      if (!medida) return;

      var estilos = window.getComputedStyle(elemento);
      var relleno =
        (parseFloat(estilos.paddingLeft) || 0) + (parseFloat(estilos.paddingRight) || 0);
      var disponible = elemento.clientWidth - relleno;

      if (disponible <= 0) return;

      elemento.style.fontSize = TAMANO_BASE + 'px';
      var anchoMedido = medida.scrollWidth;

      if (anchoMedido <= 0) return;

      var tamanoFinal = (TAMANO_BASE * disponible) / anchoMedido;
      elemento.style.fontSize = tamanoFinal.toFixed(2) + 'px';
    }

    function ajustarTodas() {
      var elementos = document.querySelectorAll(
        '.banner-rios--autoajuste .banner-rios__ajustable'
      );
      for (var i = 0; i < elementos.length; i++) {
        ajustarElemento(elementos[i]);
      }
    }

    function iniciar() {
      ajustarTodas();

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(ajustarTodas);
      }

      window.setTimeout(ajustarTodas, 400);
      window.setTimeout(ajustarTodas, 1200);
      window.setTimeout(ajustarTodas, 2500);
    }

    var pendiente = false;

    function alRedimensionar() {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(function () {
        pendiente = false;
        ajustarTodas();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    window.addEventListener('resize', alRedimensionar, { passive: true });
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-clientes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciarSeccion(seccion) {
      if (seccion.dataset.resenasIniciado === 'true') return;

      var pista = seccion.querySelector('.resenas-rios__pista');
      var cinta = seccion.querySelector('.resenas-rios__cinta');
      var tarjetas = seccion.querySelectorAll('.resenas-rios__tarjeta');
      var anterior = seccion.querySelector('.resenas-rios__flecha--anterior');
      var siguiente = seccion.querySelector('.resenas-rios__flecha--siguiente');

      if (!pista || !cinta || tarjetas.length === 0) return;

      seccion.dataset.resenasIniciado = 'true';

      var duracion = parseFloat(seccion.dataset.duracion) || 80;
      var sentido = parseFloat(seccion.dataset.sentido) || 1;
      var esperaReanudar = (parseFloat(seccion.dataset.reanudar) || 3) * 1000;
      var arrastrable = seccion.dataset.arrastrable === 'true';

      var automatico = true;
      var temporizador = null;
      var ultimoInstante = null;
      var arrastrando = false;
      var inicioX = 0;
      var inicioScroll = 0;
      var posicion = 0;

      function mitad() {
        return cinta.scrollWidth / 2;
      }

      function colocar(valor) {
        var limite = mitad();

        if (limite > 0) {
          while (valor >= limite) {
            valor = valor - limite;
          }
          while (valor < 0) {
            valor = valor + limite;
          }
        }

        posicion = valor;
        pista.scrollLeft = posicion;
      }

      function pausar() {
        automatico = false;
        window.clearTimeout(temporizador);
        temporizador = window.setTimeout(function () {
          posicion = pista.scrollLeft;
          automatico = true;
        }, esperaReanudar);
      }

      function paso(instante) {
        if (ultimoInstante === null) {
          ultimoInstante = instante;
        }

        var transcurrido = (instante - ultimoInstante) / 1000;
        ultimoInstante = instante;

        if (automatico && !arrastrando && transcurrido > 0 && transcurrido < 0.5) {
          var distancia = mitad();
          if (distancia > 0 && duracion > 0) {
            var velocidad = distancia / duracion;
            colocar(posicion + velocidad * transcurrido * sentido);
          }
        }

        window.requestAnimationFrame(paso);
      }

      pista.addEventListener(
        'scroll',
        function () {
          if (Math.abs(pista.scrollLeft - posicion) > 2) {
            posicion = pista.scrollLeft;
            pausar();
          }
        },
        { passive: true }
      );

      function anchoPaso() {
        var estilos = window.getComputedStyle(cinta);
        var hueco = parseFloat(estilos.columnGap || estilos.gap) || 0;
        return tarjetas[0].offsetWidth + hueco;
      }

      function desplazar(direccion) {
        pausar();
        pista.scrollBy({ left: anchoPaso() * direccion, behavior: 'smooth' });
      }

      if (anterior) {
        anterior.addEventListener('click', function () {
          desplazar(-1);
        });
      }

      if (siguiente) {
        siguiente.addEventListener('click', function () {
          desplazar(1);
        });
      }

      if (arrastrable) {
        pista.addEventListener('mousedown', function (evento) {
          arrastrando = true;
          inicioX = evento.pageX;
          inicioScroll = pista.scrollLeft;
          pista.classList.add('resenas-rios__pista--arrastrando');
          pausar();
        });

        window.addEventListener('mousemove', function (evento) {
          if (!arrastrando) return;
          evento.preventDefault();
          pista.scrollLeft = inicioScroll - (evento.pageX - inicioX);
        });

        window.addEventListener('mouseup', function () {
          if (!arrastrando) return;
          arrastrando = false;
          posicion = pista.scrollLeft;
          pista.classList.remove('resenas-rios__pista--arrastrando');
          pausar();
        });
      }

      window.setTimeout(function () {
        if (sentido < 0) {
          colocar(mitad() - 1);
        } else {
          colocar(0);
        }
        window.requestAnimationFrame(paso);
      }, 100);
    }

    function iniciar() {
      var secciones = document.querySelectorAll('.resenas-rios');
      for (var i = 0; i < secciones.length; i++) {
        iniciarSeccion(secciones[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();
})();
